import React from 'react'
import { smarteriseLogo } from '../assets/logo';
import { useTranslation } from 'react-i18next';

function PoweredBy({ className }: { className?: string }) {
  const { t } = useTranslation();
    
  return (
    <div
      className={`flex-none mt-auto pt-4 border-primary-border border h-[3.5rem] w-[10rem] relative p-2 rounded-md ${className}`}
    >
      <div className="w-[60%] absolute top-[-15px] bg-inherit flex items-center justify-center text-primary-blackMain text-sm font-semibold left-1/2 transform -translate-x-1/2">
        {t("sidebar.powered_by")}
      </div>
      <div className="flex justify-center items-center w-full">
        <img
          src={smarteriseLogo}
          alt="Smarterise logo"
          className="max-w-[130px]"
        />
      </div>
    </div>
  );
}

export default PoweredBy